import { StorageSyncModel } from "./StorageSyncModel/StorageSyncModel";
import { StorageConfigsModel } from "./StorageConfigsModel";
import { types, applySnapshot, applyPatch, getRoot } from "mobx-state-tree";
import { StorageUserModel } from "@models/StorageTreeModel/StorageUserModel/StorageUserModel";
import { Utils } from "@modules/utils";
import { StorageSyncViewModel } from "@viewModels/StorageSyncViewModel/StorageSyncViewModel";
import { observable } from "mobx";
import { RequestStatus } from "@constants/repositories";
import { LoginViewModel } from "@viewModels/LoginViewModel/LoginViewModel";
import { IRootTreeModel } from "domain/models";

export const StorageTreeModel = types
  .compose(
    StorageConfigsModel,
    // Model to sync entities in background
    StorageSyncModel,
    StorageUserModel
  )
  .actions((self) => {
    const model: IRootTreeModel = getRoot(self);

    const timeout: null | NodeJS.Timeout = null;

    return {
      async afterCreate() {
        await Utils.delay(3000);

        const storageSyncViewModel = new StorageSyncViewModel(model, [
          {
            // @ts-ignore
            handler: new LoginViewModel(model),
            intervalToUpdate: 10,
            name: "UserEntity",
            status: observable.box(RequestStatus.Initial),
          },
        ]);

        storageSyncViewModel.scheduleSyncs();
      },
      beforeDestroy() {
        if (timeout) clearTimeout(timeout);
      },

      clearAll() {
        this.clearConfigs();
        this.clearStorages();
      },

      clearConfigs: (): void => {
        applyPatch(self, { op: "replace", path: "/configs", value: {} });
      },

      clearStorages() {
        applySnapshot(self, { configs: self.configs });
      },
    };
  });
